module.exports = __webpack_public_path__ + "img/bi_icon_zy.40565bba.png";